import { EmeshApiClient } from "@/typescript/api_client/emesh_api/client";
import { AxiosResponse } from "axios";
import { getBearerToken } from "@/typescript/lib/common/get_bearer_token";
import {
  GetStoregroupEditResponse,
  GetStoregroupEditErrorResponse,
  GetStoregroupEditParams,
  PostStoregroupEditParams,
  PostStoregroupEditErrorResponse,
  DeleteStoregroupEditParams,
  DeleteStoregroupEditErrorResponse
} from "@/typescript/api_client/emesh_api/stores/types";

const emeshApiClient: EmeshApiClient = new EmeshApiClient(
  "/v1/storegroup/edit"
);

export async function getStoregroupEditApi(
  params?: GetStoregroupEditParams
): Promise<GetStoregroupEditResponse> {
  return await emeshApiClient
    .get({
      params: params,
      headers: {
        Authorization: getBearerToken()
      }
    })
    .then((resp: AxiosResponse<GetStoregroupEditResponse>) => {
      return Promise.resolve(resp.data as GetStoregroupEditResponse);
    })
    .catch(e => {
      if (e.data)
        return Promise.reject(e.data as GetStoregroupEditErrorResponse);
      return Promise.reject(e);
    });
}

export async function postStoregroupEditApi(
  params: PostStoregroupEditParams
): Promise<void> {
  return await emeshApiClient
    .post(
      {
        headers: {
          Authorization: getBearerToken(),
          "Content-Type": "application/json"
        }
      },
      params
    )
    .then(() => {
      return Promise.resolve();
    })
    .catch(e => {
      if (e.data)
        return Promise.reject(e.data as PostStoregroupEditErrorResponse);
      return Promise.reject(e);
    });
}

export async function deleteStoregroupEditApi(
  params: DeleteStoregroupEditParams
) {
  return await emeshApiClient
    .delete({
      params: params,
      headers: {
        Authorization: getBearerToken()
      }
    })
    .then(() => {
      return Promise.resolve();
    })
    .catch(e => {
      if (e.data)
        return Promise.reject(e.data as DeleteStoregroupEditErrorResponse);
      return Promise.reject(e);
    });
}
